import { FC } from 'react'

/**
 *
 */
const PageSection: FC = ({ children }) => <div className="flex flex-col gap-3">{children}</div>

export default PageSection
